// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.disablepage[data-v-4d7c60f0] {\n  display: none;\n}\n.pagination-link[data-v-4d7c60f0]:focus {\n  border-color: #dbdbdb !important;\n}\n.button[data-v-4d7c60f0]:focus,\n.button.is-focused[data-v-4d7c60f0] {\n  border-color: #dbdbdb !important;\n  box-shadow: none;\n}\n.pagination-link[data-v-4d7c60f0]:hover {\n  border-color: #0095db !important;\n}\n", ""]);
// Exports
module.exports = exports;
